'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import AllCasesCard from './AllCasesCard';
import { AllCasesCardProps, CaseSliderCard, RenderCardFunction } from './types';

import { ArticleCard } from '@/shared/components/articleCard';

interface MobileSliderProps {
  className?: string;
  articlesCards: CaseSliderCard[];
  allCasesCardProps: AllCasesCardProps;
  renderMobileCard?: RenderCardFunction;
}

const MobileSlider: React.FC<MobileSliderProps> = ({
  articlesCards,
  className,
  allCasesCardProps,
  renderMobileCard,
}) => (
  <div className={className}>
    <Swiper spaceBetween={12} slidesPerView="auto" className="pr-14!">
      {articlesCards.map((cards, index) => (
        <SwiperSlide key={index}>
          {renderMobileCard ? (
            renderMobileCard(cards)
          ) : (
            <ArticleCard {...cards} />
          )}
        </SwiperSlide>
      ))}
      <SwiperSlide>
        <AllCasesCard {...allCasesCardProps} />
      </SwiperSlide>
    </Swiper>
  </div>
);

export default MobileSlider;
